"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_i18next_1 = require("react-i18next");
const toolkit_1 = require("@reduxjs/toolkit");
const store_1 = require("../../store");
const input_1 = __importStar(require("../../components/input/input"));
const utils_1 = require("../../utils/utils");
const text_1 = __importStar(require("../../components/text/text"));
const primaryButton_1 = __importDefault(require("../../components/primaryButton/primaryButton"));
const myBankStatementUtils_1 = require("./myBankStatementUtils");
const colors_1 = __importDefault(require("../../styles/colors"));
const banks_1 = __importDefault(require("../../utils/banks"));
const screenConstants_1 = require("../../constants/screenConstants");
const useAppNavigation_1 = __importDefault(require("../../hooks/useAppNavigation"));
const analytics_1 = require("../../utils/analytics/analytics");
const openExternalLink_1 = __importDefault(require("../../components/openExternalLink/openExternalLink"));
const webViewer_1 = __importDefault(require("../../components/webViewer/webViewer"));
const myBankStatementDefaultTitle_1 = __importDefault(require("./myBankStatementComponents/myBankStatementDefaultTitle"));
const myBankStatementApprovedConnection_1 = __importDefault(require("./myBankStatementComponents/myBankStatementApprovedConnection"));
const myBankStatementSmsNotReceived_1 = __importDefault(require("./myBankStatementComponents/myBankStatementSmsNotReceived"));
const myBankStatementRequestForm_1 = __importDefault(require("./myBankStatementComponents/myBankStatementRequestForm"));
const MyBankStatement = ({ errors, setErrors, setCanContinueProcess, setReturnError, }) => {
    const dispatch = (0, store_1.useAppDispatch)();
    const navigation = (0, useAppNavigation_1.default)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const { hasMybankstatementRequest } = (0, store_1.useAppSelector)((state) => {
        return {
            hasMybankstatementRequest: state.home.financial_data
                ? state.home.financial_data.has_mybankstatement_request
                : false,
        };
    });
    // User info
    const [bankName, setBankName] = (0, react_1.useState)('');
    const [phoneNumber, setPhoneNumber] = (0, react_1.useState)('');
    const [bankAccountName, setBankAccountName] = (0, react_1.useState)('');
    const [bankAccountNumber, setBankAccountNumber] = (0, react_1.useState)('');
    const [ticketId, setTicketId] = (0, react_1.useState)('');
    const [password, setPassword] = (0, react_1.useState)('');
    const [buttonStatus, setButtonStatus] = (0, react_1.useState)('');
    const [showMbsWebview, setShowMbsWebview] = (0, react_1.useState)(false);
    const [showSmsNotReceived, setShowSmsNotReceived] = (0, react_1.useState)(false);
    const [mbsStatusMessage, setMbsStatusMessage] = (0, react_1.useState)(hasMybankstatementRequest ? 'Getting Status...' : '');
    const [localHasMybankstatementRequest, setLocalHasMybankstatementRequest] = (0, react_1.useState)(hasMybankstatementRequest);
    const { logEventWithExtraProperties } = (0, analytics_1.useAnalytics)();
    // ///////////////////FUNCTIONS
    const getButtonLabel = () => {
        if (buttonStatus === 'SUCCESS') {
            return 'SMS SENT';
        }
        if (buttonStatus === 'ERROR') {
            return 'SOMETHING WENT WRONG';
        }
        return 'REQUEST TO CONNECT';
    };
    // RETURN BUTTON STATUS TO DEFAULT AFTER 30s
    const checkButtonStatus = async () => {
        setTimeout(function timer() {
            if (buttonStatus === 'SUCCESS') {
                setButtonStatus('');
            }
        }, 30000);
    };
    const checkReturnError = async () => {
        if (setReturnError) {
            setReturnError(true);
        }
    };
    const connectZenithOrGtBank = () => {
        setShowMbsWebview(true);
        setButtonStatus('SUCCESS');
        setShowSmsNotReceived(false);
    };
    const connectSmsNotReceived = () => {
        setShowSmsNotReceived(true);
    };
    // REQUEST MBS
    const requestMyBankStatement = async () => {
        const payload = {
            bank_account_code: bankName,
            bank_account_name: bankAccountName,
            bank_account_number: bankAccountNumber,
            phone_number: phoneNumber,
        };
        const result = await dispatch((0, myBankStatementUtils_1.mbsRequest)(payload));
        logEventWithExtraProperties('api_call', {
            name: 'request_my_bank_statement',
            status: 'submitted',
            location: 'screen_MyBankStatement',
        });
        if ((0, toolkit_1.isFulfilled)(result)) {
            logEventWithExtraProperties('api_call', {
                name: 'request_my_bank_statement',
                status: 'success',
                location: 'screen_MyBankStatement',
            });
            setErrors(undefined);
            setButtonStatus('SUCCESS');
            checkButtonStatus();
        }
        else {
            logEventWithExtraProperties('api_call', {
                name: 'request_my_bank_statement',
                status: 'fail',
                location: 'screen_MyBankStatement',
            });
            setButtonStatus('ERROR');
            setErrors(result.payload);
        }
    };
    // REQUEST MANUAL MBS
    const requestManualMyBankStatement = async () => {
        const payload = {
            bank_account_code: bankName,
            bank_account_name: bankAccountName,
            bank_account_number: bankAccountNumber,
        };
        const result = await dispatch((0, myBankStatementUtils_1.mbsManualRequest)(payload));
        logEventWithExtraProperties('api_call', {
            name: 'request_my_bank_statement',
            status: 'submitted',
            location: 'screen_MyBankStatement',
        });
        if ((0, toolkit_1.isFulfilled)(result)) {
            logEventWithExtraProperties('api_call', {
                name: 'request_my_bank_statement',
                status: 'success',
                location: 'screen_MyBankStatement',
            });
            setErrors(undefined);
            connectZenithOrGtBank();
        }
        else {
            logEventWithExtraProperties('api_call', {
                name: 'request_my_bank_statement',
                status: 'fail',
                location: 'screen_MyBankStatement',
            });
            setButtonStatus('ERROR');
            setErrors(result.payload);
        }
    };
    // CONFIRM MBS CONNECTION
    const confirmMBS = async () => {
        const payload = {
            ticket_no: ticketId,
            statement_password: password,
        };
        // Add bank account
        const result = await dispatch((0, myBankStatementUtils_1.mbsIntegration)(payload));
        logEventWithExtraProperties('api_call', {
            name: 'confirm_my_bank_statement',
            status: 'submitted',
            location: 'screen_MyBankStatement',
        });
        if ((0, toolkit_1.isFulfilled)(result)) {
            logEventWithExtraProperties('api_call', {
                name: 'confirm_my_bank_statement',
                status: 'success',
                location: 'screen_MyBankStatement',
            });
            setErrors(undefined);
            setCanContinueProcess(true);
            return result.payload;
        }
        logEventWithExtraProperties('api_call', {
            name: 'confirm_my_bank_statement',
            status: 'fail',
            location: 'screen_MyBankStatement',
        });
        setErrors(result.payload);
        checkReturnError();
        navigation.navigate(screenConstants_1.LOAN_APPLICATION_UPDATE_STATEMENTS_SCREEN);
        return null;
    };
    // GET MBS STATUS EVERY MINUTE
    const getMbsStatus = async () => {
        const result = await dispatch((0, myBankStatementUtils_1.getMbsStatusMessage)());
        if ((0, toolkit_1.isFulfilled)(result)) {
            setMbsStatusMessage(result.payload.message);
            return result;
        }
        setMbsStatusMessage('No Status Available');
        return result;
    };
    const openLendigoLinks = (lendigoLink) => {
        (0, openExternalLink_1.default)({
            navigation,
            url: lendigoLink,
            webViewData: {
                sourcePage: screenConstants_1.MY_BANK_STATEMENT_SCREEN,
                sourceScreen: 'myBankStatement',
                name: 'myBankStatement',
                title: 'myBankStatement Instructions',
            },
        });
    };
    // ///////////////////END FUNCTIONS
    // ///////////////////USEEFFECTS
    (0, react_1.useEffect)(() => {
        if (setReturnError) {
            if (!!setReturnError === true) {
                setReturnError(false);
            }
        }
    }, [setReturnError]);
    if (hasMybankstatementRequest || localHasMybankstatementRequest) {
        getMbsStatus();
        setTimeout(function timer() {
            getMbsStatus();
        }, 60000);
    }
    (0, react_1.useEffect)(() => {
        if (buttonStatus === 'SUCCESS') {
            checkButtonStatus();
        }
    }, [buttonStatus]);
    // Restore button status after user changes bank option
    (0, react_1.useEffect)(() => {
        if (buttonStatus === 'ERROR') {
            setButtonStatus('');
        }
    }, [bankName]);
    // ///////////////////END USEEFFECTS
    // ///////////////////COMPONENTS
    const approveMbsConnection = (react_1.default.createElement(react_1.default.Fragment, null, (hasMybankstatementRequest || localHasMybankstatementRequest || buttonStatus === 'SUCCESS') && (react_1.default.createElement(myBankStatementApprovedConnection_1.default, { confirmMBS: confirmMBS, connectSmsNotReceived: connectSmsNotReceived, errors: errors, mbsStatusMessage: mbsStatusMessage, password: password, setPassword: setPassword, ticketId: ticketId, setTicketId: setTicketId }))));
    // ///////////////////END COMPONENTS
    const content = bankName !== '' ? (react_1.default.createElement(react_1.default.Fragment, null, bankName !== '058152052' && bankName !== '057150013' ? (react_1.default.createElement(react_1.default.Fragment, null, hasMybankstatementRequest || localHasMybankstatementRequest ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(myBankStatementDefaultTitle_1.default, null),
        approveMbsConnection)) : (react_1.default.createElement(myBankStatementRequestForm_1.default, { bankAccountName: bankAccountName, bankAccountNumber: bankAccountNumber, bankName: bankName, requestManualMyBankStatement: requestManualMyBankStatement, requestMyBankStatement: requestMyBankStatement, setBankAccountName: setBankAccountName, setBankAccountNumber: setBankAccountNumber, setBankName: setBankName, buttonStatus: buttonStatus, errors: errors, getButtonLabel: getButtonLabel, phoneNumber: phoneNumber, setPhoneNumber: setPhoneNumber, specialForm: bankName === '058152052' || bankName === '057150013' })))) : (
    // IF ITS ZEITH OR GTBANK
    react_1.default.createElement(react_1.default.Fragment, null, showMbsWebview || showSmsNotReceived ? (react_1.default.createElement(react_1.default.Fragment, null,
        bankName === '058152052' && (react_1.default.createElement(react_1.default.Fragment, null, hasMybankstatementRequest || localHasMybankstatementRequest ? (react_1.default.createElement(react_1.default.Fragment, null, showSmsNotReceived ? (react_1.default.createElement(myBankStatementSmsNotReceived_1.default, { connectZenithOrGtBank: connectZenithOrGtBank, openLendigoLinks: openLendigoLinks })) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(myBankStatementDefaultTitle_1.default, null),
            approveMbsConnection)))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(myBankStatementDefaultTitle_1.default, null),
            react_native_1.Platform.OS === 'web' ? (react_1.default.createElement(primaryButton_1.default, { title: "Click to see how to connect to GT Bank", onPress: () => openLendigoLinks('https://support.lendigo.ng/portal/en/kb/articles/how-to-upload-your-bank-statement-automatically-mbs-gtbank'), eventName: "go_to_Lendigo_instructions", color: colors_1.default.COLOR_SECONDARY })) : (react_1.default.createElement(webViewer_1.default, { windowHeight: "68%", docSrc: "https://support.lendigo.ng/portal/en/kb/articles/how-to-upload-your-bank-statement-automatically-mbs-gtbank" })),
            react_1.default.createElement(react_native_1.View, { style: react_native_1.Platform.OS !== 'web' ? { top: 60 } : { top: 0 } },
                react_1.default.createElement(primaryButton_1.default, { title: "CONTINUE", onPress: () => setLocalHasMybankstatementRequest(true), eventName: "request_connect_my_bank_statement", color: colors_1.default.COLOR_PRIMARY })))))),
        bankName === '057150013' && (react_1.default.createElement(react_1.default.Fragment, null, hasMybankstatementRequest || localHasMybankstatementRequest ? (react_1.default.createElement(react_1.default.Fragment, null, showSmsNotReceived ? (react_1.default.createElement(myBankStatementSmsNotReceived_1.default, { connectZenithOrGtBank: connectZenithOrGtBank, openLendigoLinks: openLendigoLinks })) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(myBankStatementDefaultTitle_1.default, null),
            approveMbsConnection)))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(myBankStatementDefaultTitle_1.default, null),
            react_native_1.Platform.OS === 'web' ? (react_1.default.createElement(primaryButton_1.default, { title: "Click to see how to connect to Zenith Bank", onPress: () => openLendigoLinks('https://support.lendigo.ng/portal/en/kb/articles/how-to-upload-your-bank-statement-automatically-mbs-zenith-bank'), eventName: "go_to_Lendigo_instructions", color: colors_1.default.COLOR_SECONDARY })) : (react_1.default.createElement(webViewer_1.default, { windowHeight: "68%", docSrc: "https://support.lendigo.ng/portal/en/kb/articles/how-to-upload-your-bank-statement-automatically-mbs-zenith-bank" })),
            react_1.default.createElement(react_native_1.View, { style: react_native_1.Platform.OS !== 'web' ? { top: 60 } : { top: 0 } },
                react_1.default.createElement(primaryButton_1.default, { title: "CONTINUE", onPress: () => setLocalHasMybankstatementRequest(true), eventName: "request_connect_my_bank_statement", color: colors_1.default.COLOR_PRIMARY })))))))) : (
    // IF ITS NOT ZENITH OR GT BANK
    react_1.default.createElement(react_1.default.Fragment, null, hasMybankstatementRequest || localHasMybankstatementRequest ? (react_1.default.createElement(react_1.default.Fragment, null, showSmsNotReceived ? (react_1.default.createElement(myBankStatementSmsNotReceived_1.default, { connectZenithOrGtBank: connectZenithOrGtBank, openLendigoLinks: openLendigoLinks })) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(myBankStatementDefaultTitle_1.default, null),
        approveMbsConnection)))) : (react_1.default.createElement(myBankStatementRequestForm_1.default, { bankAccountName: bankAccountName, bankAccountNumber: bankAccountNumber, bankName: bankName, requestManualMyBankStatement: requestManualMyBankStatement, requestMyBankStatement: requestMyBankStatement, setBankAccountName: setBankAccountName, setBankAccountNumber: setBankAccountNumber, setBankName: setBankName, errors: errors, specialForm: bankName === '058152052' || bankName === '057150013' })))))))) : (
    // IF NO BANK SELECTED BUT A REQUEST WAS ALREADY MADE
    react_1.default.createElement(react_1.default.Fragment, null, hasMybankstatementRequest || localHasMybankstatementRequest ? (react_1.default.createElement(react_1.default.Fragment, null, showSmsNotReceived ? (react_1.default.createElement(myBankStatementSmsNotReceived_1.default, { connectZenithOrGtBank: connectZenithOrGtBank, openLendigoLinks: openLendigoLinks })) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(myBankStatementDefaultTitle_1.default, null),
        approveMbsConnection)))) : (
    // ELSE IT HAS NO BANK SO SHOW OPTIONS
    react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_TITLE, style: { fontSize: 20, marginBottom: 5, fontWeight: 'bold', textAlign: 'center' } }, t('myBankStatement.connect_bank')),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PICKER, label: "Choose Bank", choices: banks_1.default, value: bankName, setValue: setBankName, error: (0, utils_1.getError)('bank_account_code', errors) })))));
    return content;
};
exports.default = MyBankStatement;
